import React from "react";
import ModalShell from "./ModalShell";
import {
  PlayerTournament,
  PlayerTournamentGroup,
  formatTournamentDate,
} from "../tournamentPlay";

interface Props {
  tournament: PlayerTournament;
  onClose: () => void;
}

// Read-only "draw" view shown when a player taps a tournament BEFORE its date.
// Lists every group with its tee time and players so the field can see the
// pairings ahead of the day. Starting the round is only allowed on the day
// itself (handled by the caller), so there's no action here.
export default function TournamentDrawModal({ tournament: t, onClose }: Props) {
  // Prefer the full draw; fall back to just the player's own group for older
  // payloads that predate the all-groups field.
  const groups: PlayerTournamentGroup[] =
    t.groups && t.groups.length > 0
      ? t.groups
      : [
          {
            id: t.groupId,
            name: t.groupName,
            teeTime: t.teeTime,
            players: t.players,
            final: t.groupFinal,
          },
        ];

  const fmtHcp = (n?: number) =>
    typeof n !== "number" ? "" : n < 0 ? `+${Math.abs(n)}` : `${n}`;

  return (
    <ModalShell
      title={t.tournamentName}
      subtitle={`${formatTournamentDate(t.date)}${
        t.course?.name ? ` · ${t.course.name}` : ""
      }`}
      onClose={onClose}
      className="cg-draw-modal"
    >
      <p className="cg-modal-note">
        Tournament starts on the day of the event — the scorecard opens then.
      </p>
      <div className="cg-draw-groups">
        {groups.map((g) => (
          <section key={g.id} className="cg-draw-group">
            <header className="cg-draw-group-head">
              <span className="cg-draw-group-name">
                {g.name}
                {g.id === t.groupId && (
                  <span className="cg-draw-group-you"> · your group</span>
                )}
              </span>
              {g.teeTime && (
                <span className="cg-draw-group-tee">{g.teeTime}</span>
              )}
            </header>
            <ul className="cg-draw-players">
              {g.players.map((p, i) => (
                <li key={`${g.id}-${i}`} className="cg-draw-player">
                  <span className="cg-draw-player-name">{p.name}</span>
                  {typeof p.handicapIndex === "number" && (
                    <span className="cg-draw-player-hcp">
                      {fmtHcp(p.handicapIndex)}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </ModalShell>
  );
}
